import React, { ReactElement } from 'react';
import { LayoutProps, SpaceProps, space, layout } from 'styled-system';
import styled, { CSSProperties } from 'styled-components';
import Button, { ButtonType } from '@ingka/button';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/focus/dist/style.css';

//This is the Skapa component "Button"

export enum ButtonTypeEnum {
  primary = 'primary',
  emphasised = 'emphasised',
  secondary = 'secondary',
  tertiary = 'tertiary',
  danger = 'danger',
  imageOverlay = 'imageOverlay'
}

export enum ButtonAlignEnum {
  right = 'right',
  left = 'left'
}

const Box = styled.div`
  ${layout}
  ${space}
`;

type ExtendProps = React.CSSProperties &
  SpaceProps &
  LayoutProps &
  React.HTMLAttributes<HTMLDivElement>;

export interface ButtonProps extends ExtendProps {
  children?: React.ReactNode | React.ReactNode[];
  className?: string;
  disabled?: boolean;
  expanding?: boolean;
  fluid?: boolean;
  href?: string;
  htmlType?: string;
  iconOnly?: boolean;
  iconPosition?: 'leading' | 'trailing';
  inverseTheme?: boolean;
  loading?: boolean;
  loadingSrText?: string | ReactElement;
  newWindow?: boolean;
  onClick?: (...args: any[]) => any;
  prefix?: string;
  ssrIcon?: (...args: any[]) => any;
  text?: string | ReactElement;
  type?: ButtonType | undefined;
  expandedOnTouchDevice?: boolean;
  dataTestId?: string;
  size?: 'xsmall' | 'small' | 'medium';
  buttonStyle?: CSSProperties | undefined;
  buttonId?: string;
}

const SkapaButton = ({
  children,
  className,
  disabled,
  expanding,
  fluid,
  href,
  htmlType,
  iconOnly,
  iconPosition,
  inverseTheme,
  loading,
  loadingSrText,
  newWindow,
  onClick,
  prefix,
  size,
  ssrIcon,
  text,
  type,
  expandedOnTouchDevice,
  dataTestId,
  buttonStyle,
  buttonId,
  ...props
}: ButtonProps) => {
  return (
    <Box {...props}>
      <Button
        children={children}
        className={className}
        disabled={disabled}
        expanding={expanding}
        fluid={fluid}
        href={href}
        htmlType={htmlType as 'button' | 'submit' | 'reset'}
        iconOnly={iconOnly}
        iconPosition={iconPosition}
        inverseTheme={inverseTheme}
        loading={loading}
        loadingSrText={loadingSrText}
        newWindow={newWindow}
        onClick={onClick}
        prefix={prefix}
        size={size}
        ssrIcon={ssrIcon}
        text={text}
        type={type}
        expandedOnTouchDevice={expandedOnTouchDevice}
        data-testid={dataTestId}
        style={{ ...buttonStyle, width: '100%' }}
        id={buttonId}
        aria-pressed={props['aria-pressed']}
        aria-expanded={props['aria-expanded']}
      />
    </Box>
  );
};

export default SkapaButton;
